module.exports = __webpack_public_path__ + "img/ssss.86f07a5b.png";